import type {
  AssistantTranslationViewTraitConfigTranslation,
  AssistantViewTraitConfig,
  AssistantViewTraitConfigCompliance,
  AssistantViewTraitConfigTranslationCompliance,
} from '../../../_generated';

/**
 * Returns true when the trait config has removePromptInput set to true
 * (e.g. comparison/extract/compliance with "Remove Prompt Input" enabled).
 */
export function hasRemovePromptInput(traitConfig: unknown): boolean {
  return (
    !!traitConfig &&
    typeof traitConfig === 'object' &&
    'removePromptInput' in traitConfig &&
    (traitConfig as Record<string, unknown>)['removePromptInput'] === true
  );
}

/**
 * Requires only the behavioral fields the new-model (skill.md) compliance
 * config carries (SB-3325 T4/KD-2): a behavioral-only config passes, and
 * legacy configs with stale extra keys (validationCriteria, …) still pass —
 * `in`-checks tolerate extras. Requiring the removed free-text fields here
 * would silently skip the edit patch and break the chat compliance phases.
 */
export const isComplianceConfig = (
  config: AssistantViewTraitConfig,
): config is AssistantViewTraitConfigCompliance => {
  return (
    typeof config === 'object' &&
    config != null &&
    'userWillUploadReferenceDocuments' in config &&
    'removePromptInput' in config
  );
};

export const isComplianceConfigTranslation = (
  translation: AssistantTranslationViewTraitConfigTranslation,
): translation is AssistantViewTraitConfigTranslationCompliance => {
  return (
    typeof translation === 'object' &&
    translation != null &&
    'labelForExpectedDocuments' in translation &&
    typeof translation.labelForExpectedDocuments === 'object' &&
    translation.labelForExpectedDocuments != null &&
    'referenceLabel' in translation.labelForExpectedDocuments &&
    typeof translation.labelForExpectedDocuments.referenceLabel === 'string' &&
    'regularLabel' in translation.labelForExpectedDocuments &&
    typeof translation.labelForExpectedDocuments.regularLabel === 'string'
  );
};
